/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { StepType } from './step-type';
import { ChecklistStepSignature } from './checklist-step-signature';
import { CustomStepConfig } from './custom-step-config';
import { ChecklistStepImage } from './checklist-step-image';

export class ChecklistStep {
  id: number;
  title: string;
  description: string;
  isPickup: boolean;
  isCustomStep: boolean;
  stepType: StepType;
  completedDateTime: string;
  signatures: ChecklistStepSignature[] = [];
  customStepConfig: CustomStepConfig;
  latitude?: number;
  longitude?: number;
  stepPhotos: ChecklistStepImage[] = [];
}
